import "./FilesModal.css";
import "./FilesModalResponsive.css";

import { Dispatch, SetStateAction, useEffect } from "react";
import { useAppContext } from "../../App";

type FilesModalProps = {
  file: {
    path: string;
    title?: string;
    type: string;
  };
  closeModal: Dispatch<SetStateAction<SetStateAction<boolean>>>;
};

function FilesModal({ file }: FilesModalProps) {
  const appContext = useAppContext();
  console.log(file)

  useEffect(() => {
    window.addEventListener("keydown", (e) => {
      console.log(e.key);
      if (e.key === "Escape") {
        appContext?.setViewFile(null);
      }
    });

    return () => {
      window.removeEventListener("keydown", () => {});
    };
  }, [appContext]);

  return (
    <div
      className="files-modal-container"
      onClick={() => {
        appContext?.setViewFile(null);
      }}
    >
      <div
        className={`files-modal-render ${
          file.type !== "image" && "resize-file-view"
        }`}
      >
        {file.type === "image" ? (
          <img
            src={file.path}
            alt={file.title}
            id="gallery-image-view"
            onContextMenu={(e) => e.preventDefault()}
          />
        ) : (
          <iframe
            src={file.path}
            title={file.title}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
            onKeyDown={(e) => {
              console.log(e.key);
              if (e.key === "Escape") {
                appContext?.setViewFile(null);
              }
            }}
          ></iframe>
        )}
      </div>
    </div>
  );
}

export default FilesModal;
